import { TicketDetails } from "features/types";
import React from "react";
import BarcodeRenderItem from "./components/BarcodeRenderItem";
import { Swiper, SwiperSlide } from "components/Swiper";
import { View } from "react-native";
export interface BarcodeCarouselProps {
  tickets: TicketDetails[];
  currentIndex: number;
  setCurrentIndex: React.Dispatch<React.SetStateAction<number>>;
}
const BarcodeCarousel: React.FC<BarcodeCarouselProps> = ({
  tickets,
  setCurrentIndex,
}) => {
  return (
    <div>
      <Swiper
        slidesPerView="auto"
        centeredSlides={true}
        onSlideChange={({ activeIndex }) => setCurrentIndex(activeIndex)}
        slideToClickedSlide
      >
        {tickets.map((ticket, index) => (
          <SwiperSlide key={ticket.id}>
            <View style={{ paddingHorizontal: 10 }}>
              <BarcodeRenderItem
                ticket={ticket}
                index={index}
                ticketsWithBarcode={tickets}
              />
            </View>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default BarcodeCarousel;
